import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
    ActivatedRoute,
    Data,
    NavigationEnd,
    Router,
    RouterOutlet,
} from "@angular/router";

import { filter, map, Observable } from "rxjs";

import { LayoutMarginType } from "@hermes/utils-generic-constants";

/**
 * Main component displaying the rooter outlet
 */
@Component({
    selector: "h-main-content",
    imports: [RouterOutlet, AsyncPipe],
    templateUrl: "./main-content.component.html",
    styleUrls: ["./main-content.component.scss"],
})
export class MainContentComponent {
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);

    public layoutSystemObservable$: Observable<LayoutMarginType> =
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(
                () =>
                    this.getMergedRouteData(this.activatedRoute.root)
                        .layoutSystem,
            ),
        );

    // We use recursive function to get active route data
    private getMergedRouteData(route: ActivatedRoute): Data {
        if (route.firstChild) {
            return {
                ...route.snapshot.data,
                ...this.getMergedRouteData(route.firstChild),
            };
        }

        return route.snapshot.data;
    }
}
